import axiosInstance, { silentRequest } from "../utils/axiosConfig";
import {
  LeaveBalanceRequestsListResponse,
  LeaveBalanceRequestDetailResponse,
} from "../types/leaveBalanceRequest";

export interface FetchLeaveBalanceRequestsParams {
  status?: "pending" | "approved" | "rejected" | "cancelled" | "all";
  userId?: string;
  page?: number;
  limit?: number;
}

export const fetchLeaveBalanceRequests = (
  params: FetchLeaveBalanceRequestsParams = {},
) =>
  axiosInstance.get<LeaveBalanceRequestsListResponse>(
    "/api/leave-balance-requests",
    { params, withCredentials: true },
  );

export const fetchMyLeaveBalanceRequests = (
  params: FetchLeaveBalanceRequestsParams = {},
) =>
  axiosInstance.get<LeaveBalanceRequestsListResponse>(
    "/api/leave-balance-requests/my-requests",
    { params, withCredentials: true },
  );

export const fetchLeaveBalanceRequestById = (id: string) =>
  axiosInstance.get<LeaveBalanceRequestDetailResponse>(
    `/api/leave-balance-requests/${id}`,
    { withCredentials: true },
  );

export const approveLeaveBalanceRequest = (
  id: string,
  reviewRemarks?: string,
) =>
  axiosInstance.patch<LeaveBalanceRequestDetailResponse>(
    `/api/leave-balance-requests/${id}/approve`,
    { reviewRemarks },
    { withCredentials: true },
  );

export const rejectLeaveBalanceRequest = (id: string, reviewRemarks?: string) =>
  axiosInstance.patch<LeaveBalanceRequestDetailResponse>(
    `/api/leave-balance-requests/${id}/reject`,
    { reviewRemarks },
    { withCredentials: true },
  );

export const cancelLeaveBalanceRequest = (id: string, reviewRemarks?: string) =>
  axiosInstance.patch<LeaveBalanceRequestDetailResponse>(
    `/api/leave-balance-requests/${id}/cancel`,
    { reviewRemarks },
    { withCredentials: true },
  );

export const fetchPendingLeaveBalanceCount = async (): Promise<number> => {
  try {
    const { data } = await silentRequest.get<LeaveBalanceRequestsListResponse>(
      "/api/leave-balance-requests",
      { params: { status: "pending", limit: 1, page: 1 }, withCredentials: true },
    );
    return data?.total ?? 0;
  } catch {
    return 0;
  }
};
